
<script setup>
/* eslint-disable */
import { onMounted, computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useLiveSportsStore } from '@/stores/live_sports';
import { useLiveSportOverview } from '@/stores/live_sport_overview';
import { useFixtureStore } from '@/stores/fixture';
import LiveFixtureDoubleMarket from './LiveFixtureDoubleMarket.vue';
import commonSvgs from '@/assets/svgs/commonSvgs.json'
import Loader from '@/components/Common/Loader.vue'
const svg_data = ref(commonSvgs);

const router = useRouter();
const liveSportsStore = useLiveSportsStore();
const liveSportOverviewStore = useLiveSportOverview();
const fixtureStore = useFixtureStore();

const props = defineProps({
	primary_overview_market: {
		type: Object,
		required: true,
	},
	secondary_overview_market: {
		type: Object,
		required: true,
	},
	landing: {
		type: Boolean,
		required: false,
		default: false
	},
	fixtures_count: {
		type: Number,
		default: 5
	}
});

const competitions = computed(() => {
	let fixtures = liveSportOverviewStore.highlightFixtures;

	if (props.landing) {
		fixtures = _.take(fixtures, props.fixtures_count);
	} else {
		fixtures = _.take(fixtures, 15);
	}

	return _.groupBy(fixtures, 'competition_region_name');
})

</script>
<template>
	<div id="live" class="tab-content highlight-live">
		<Loader v-if="liveSportOverviewStore.loading"></Loader>
		<div v-else class="live-info-outer-main" v-for="(competition, index) in competitions" :key="index">

			<div class="live-info-outer">
				<div class="live-info-inner">
					<div class="live-info-team">
						<div class="live-match">
							<div class="team-flag">
								<img :src="'/assets' + competition[0].region_icon_url" alt="">
							</div>
							<div class="live-match-name">
								<h3>{{ competition[0].region_name }} - {{ competition[0].competition_name }}</h3>
							</div>
						</div>
					</div>

					<div class="full-time-top top-title-dash">
						<template v-for="(odd, id) in primary_overview_market?.odd_names" :key="id">
							<span v-if="odd != ''">{{ odd }}</span>
						</template>
					</div>

					<div class="match-goal-top top-title-dash">
						<template v-for="(odd, id) in secondary_overview_market?.odd_names" :key="id">
							<span v-if="odd != ''">{{ odd }}</span>
						</template>
						<span class="bet-column-empty"></span>

					</div>
				</div>

				<LiveFixtureDoubleMarket v-for="(fixture, index) in competition"
					:key="index"
					:primary_overview_market="primary_overview_market"
					:secondary_overview_market="secondary_overview_market"
					:fixture="fixture"
				/>
			</div>
		</div>
	</div>
</template>
<style scoped>
	@media (hover: hover) {
	.live-bet-dashboard .live-tab-info .live-info-outer .live-info-inner:nth-child(n+2):hover {
		background: var(--light-dark);
		border-radius: 3px;
	}
	}
	@media (hover: none) {
	.live-bet-dashboard .live-tab-info .live-info-outer .live-info-inner:nth-child(n+2):hover {
		background: none; /* Remove background */
		border-radius: none; /* Remove border-radius */
	}
	}

	:deep(.loading) {
		margin-right: 30px;
		display: flex;
		/* padding-top: 20px; */
		/* margin-left: 40%; */
		height: 100%;
		margin-left: 0px;
		max-height: 100%;
		min-height: 300px;
		justify-content: center;
		/* text-align: center; */
		align-items: center;
		padding-top: 0px;
	}

	:deep(.lds-ring) {
		display: inline-block;
		position: relative;
		width: 25px;
		height: 25px;
		bottom: 12.5px;
	}
</style>